import React from 'react';
import { RejectsChartContainer } from '../charts';
import ChartTab from './ChartTab';

interface RejectsTabProps {
  machineSerialNo?: string;
  lineId?: string; // Line ID for line-level aggregated data
  shifts?: string[];
  syncGroup?: string;
  activeSubTab?: 'ratio' | 'rejects' | 'events';
  onActiveSubTabChange?: (tab: 'ratio' | 'rejects' | 'events') => void;
}

const RejectsTab: React.FC<RejectsTabProps> = ({ 
  machineSerialNo, 
  lineId,
  shifts, 
  syncGroup,
  activeSubTab,
  onActiveSubTabChange
}) => {
  // Suppress unused syncGroup warning
  React.useEffect(() => { void syncGroup; }, [syncGroup]);

  return (
    <ChartTab>
      <RejectsChartContainer 
        machineSerialNo={machineSerialNo}
        lineId={lineId}
        shifts={shifts}
        activeSubTab={activeSubTab}
        onActiveSubTabChange={onActiveSubTabChange}
      />
    </ChartTab>
  );
};

export default RejectsTab;
